import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { createRef, useRef, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import { IconV2 } from "../icon_v2";
import "./carousel.css";
const Carousel = ({ items, onPrevious, onNext }) => {
    const sliderRef = useRef(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const legendRefs = useRef(items.map(() => createRef()));
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        beforeChange: (current, next) => setCurrentSlide(next),
    };
    const callLegendFunctions = () => {
        legendRefs.current.forEach((ref) => {
            if (ref.current) {
                ref.current.onSlideChange();
            }
        });
    };
    const goToPrevious = () => {
        if (sliderRef.current) {
            sliderRef.current.slickPrev();
        }
        if (onPrevious) {
            onPrevious();
        }
        callLegendFunctions();
    };
    const goToNext = () => {
        if (sliderRef.current) {
            sliderRef.current.slickNext();
        }
        if (onNext) {
            onNext();
        }
        callLegendFunctions();
    };
    const isLastSlide = currentSlide === items.length - 1;
    const buttonStyle = "border-2 border-buttons-secondary dark:border-dark-buttons-secondary rounded-md hover:bg-buttons-secondary-bg-hover p-2 cursor-pointer disabled:cursor-not-allowed disabled:border-dark dark:disabled:border-dark-dark disabled:bg-buttons-disabled-background dark:disabled-bg-dark-buttons-disabled-background disabled:text-buttons-disabled-text dark:disabled:text-dark-buttons-disabled-text disabled:opacity-50";
    return (_jsxs("div", { id: "legend-carousel", className: "legend-carousel bg-container-light dark:bg-dark-container-light flex items-center", children: [_jsxs("div", { className: "ml-2 flex-none text-nowrap", children: [_jsx("button", { id: "prevLegend", onClick: goToPrevious, className: `${buttonStyle} mr-2`, disabled: currentSlide === 0, children: _jsxs("div", { className: "text-tertiary dark:text-dark-tertiary", children: [_jsx(IconV2, { type: "fa", icon: {
                                        icon: ["far", "angle-left"],
                                        fixedWidth: true,
                                    } }), _jsx("span", { className: "sr-only", children: "Previous" })] }) }), _jsx("button", { id: "nextLegend", onClick: goToNext, className: buttonStyle, disabled: isLastSlide, children: _jsxs("div", { className: "text-tertiary dark:text-dark-tertiary", children: [_jsx(IconV2, { type: "fa", icon: {
                                        icon: ["far", "angle-right"],
                                        fixedWidth: true,
                                    } }), _jsx("span", { className: "sr-only", children: "Next" })] }) })] }), _jsx("div", { className: "carousel-container mx-2 w-1/2 flex-1", children: _jsx(Slider, Object.assign({ ref: sliderRef }, settings, { children: items.map((item, index) => (_jsx("div", { className: "p-2 text-center", children: React.isValidElement(item)
                            ? React.cloneElement(item, {
                                ref: legendRefs.current[index],
                            })
                            : item }, index))) })) })] }));
};
export default Carousel;
